module.exports = __webpack_public_path__ + "img/3.60796b7b.jpg";